import { CicReasonAppliesTo } from 'constants/cicReason';
import { getConditionalObject } from 'utils/data';

export class CicFeeReasonsApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCicFeeReasons() {
    return this.#http.get('/api/cic-fee-reasons');
  }

  async getCicLoanTermReasons({ activeOnly = false } = {}) {
    return this.#http.get('/api/cic-fee-reasons', {
      params: {
        appliesTo: CicReasonAppliesTo.LOAN_TERM,
        ...getConditionalObject(activeOnly, { activeOnly }),
      },
    });
  }

  async getActiveCicFeeReasons() {
    return this.#http.get('/api/cic-fee-reasons', {
      params: { appliesTo: CicReasonAppliesTo.FEE, activeOnly: true },
    });
  }

  async createCicFeeReasons(body) {
    return this.#http.post('/api/cic-fee-reasons', body);
  }

  async editCicFeeReasons({ cicFeeReasonId, ...body }) {
    return this.#http.put(`/api/cic-fee-reasons/${cicFeeReasonId}`, body);
  }

  async deleteCicFeeReasons({ cicFeeReasonId }) {
    return this.#http.delete(`/api/cic-fee-reasons/${cicFeeReasonId}`);
  }

  async reorderCicFeeReasons({ cicFeeReasonIds }) {
    return this.#http.put('/api/cic-fee-reasons/sort-order', { cicFeeReasonIds });
  }
}
